import React from 'react';
import { Button } from './ui/button';
import { Hexagon, Cpu, CheckCircle } from 'lucide-react';

const ProjectFocus = () => {
  const handleContact = () => {
    window.open('https://t.me/darkerthandeath', '_blank');
  };

  const blockchainFeatures = [
    'End-to-end smart contract development and audits',
    'Secure, scalable on-chain infrastructure',
    'Tokenomics design and protocol architecture'
  ];

  const aiFeatures = [
    'Production-grade ML models and AI pipelines',
    'AI agents, recommendations, and NLP systems',
    'Scalable, automated decision-making'
  ];

  return (
    <section id="products" className="py-24 bg-gradient-to-b from-[#0a0e1a] to-[#0f1420] relative">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
            What's Your Project Focus?
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Choose where you need our expertise. Or both. We're equally skilled in blockchain engineering and AI/ML development.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 mt-16">
          {/* Blockchain Card */}
          <div className="group relative bg-gradient-to-br from-[#1a1f35] to-[#0f1420] rounded-2xl border border-white/10 overflow-hidden hover:border-[#00d4ff]/50 transition-all duration-500">
            {/* Background Image */}
            <div className="absolute inset-0 opacity-20 group-hover:opacity-30 transition-opacity duration-500">
              <img
                src="https://images.unsplash.com/photo-1568952433726-3896e3881c65"
                alt=""
                className="w-full h-full object-cover"
              />
            </div>

            <div className="relative p-8 space-y-6">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-[#00d4ff] to-[#0ea5e9] flex items-center justify-center">
                  <Hexagon size={32} className="text-white" />
                </div>
                <h3 className="text-3xl font-bold text-white">Blockchain</h3>
              </div>

              <p className="text-gray-300 leading-relaxed">
                From protocol design and smart contract engineering to audits, tokenomics and scalable infrastructure—we build reliable decentralized systems.
              </p>

              <div className="space-y-3">
                {blockchainFeatures.map((feature, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <CheckCircle size={20} className="text-[#00d4ff] mt-1 flex-shrink-0" />
                    <span className="text-gray-300">{feature}</span>
                  </div>
                ))}
              </div>

              <Button
                onClick={handleContact}
                className="w-full bg-gradient-to-r from-[#ff6b35] to-[#ff2e63] hover:from-[#ff7b45] hover:to-[#ff3e73] text-white py-3 rounded-lg transition-all duration-300 mt-6"
              >
                Talk to an Expert
              </Button>
            </div>
          </div>

          {/* AI & Machine Learning Card */}
          <div className="group relative bg-gradient-to-br from-[#1a1f35] to-[#0f1420] rounded-2xl border border-white/10 overflow-hidden hover:border-[#ff6b35]/50 transition-all duration-500">
            {/* Background Image */}
            <div className="absolute inset-0 opacity-20 group-hover:opacity-30 transition-opacity duration-500">
              <img
                src="https://images.pexels.com/photos/18068747/pexels-photo-18068747.png"
                alt=""
                className="w-full h-full object-cover"
              />
            </div>

            <div className="relative p-8 space-y-6">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-[#ff6b35] to-[#ff2e63] flex items-center justify-center">
                  <Cpu size={32} className="text-white" />
                </div>
                <h3 className="text-3xl font-bold text-white">AI & Machine Learning</h3>
              </div>

              <p className="text-gray-300 leading-relaxed">
                We build data pipelines, ML models, AI agents, recommendation engines and NLP systems to power smart, automated decision-making.
              </p>

              <div className="space-y-3">
                {aiFeatures.map((feature, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <CheckCircle size={20} className="text-[#ff6b35] mt-1 flex-shrink-0" />
                    <span className="text-gray-300">{feature}</span>
                  </div>
                ))}
              </div>

              <Button
                onClick={handleContact}
                className="w-full bg-gradient-to-r from-[#ff6b35] to-[#ff2e63] hover:from-[#ff7b45] hover:to-[#ff3e73] text-white py-3 rounded-lg transition-all duration-300 mt-6"
              >
                Talk to an Expert
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectFocus;